<template>
  <transition-group
    tag="div"
    name="campaign-list"
    class="campaign-list"
    appear
  >
    <component
      v-for="campaign in campaignList"
      :is="getCampaignType(campaign)"
      class="item"
      data-cy="campaign-item"
      v-bind="$attrs"
      :key="campaign.slug || campaign.id"
      :ref="campaign.id"
      :value="campaign.value | toNumber"

      :banner="campaign"
      is-result

      :campaign="campaign"
      :has-favorite="hasFavorite"
      :is-cashback="!hideCashback && (campaign.eventData || {}).is_cashback"
      :cashback-value="getCashbackValue(campaign)"

      @click.native="click(campaign)"
      @favorite="$emit('favorite', campaign)"
    />
  </transition-group>
</template>

<script>
import CampaignCard from '@components/Campaign/CampaignCard'
import CampaignBanner from '@components/Banner/BannerDetails'

export default {
  components: { CampaignCard, CampaignBanner },

  filters: {
    toNumber (value) {
      if (typeof value === 'number') { return value }
      if (typeof value === 'string') { return +value.replace(/\D/g, '') }
      return value
    }
  },

  props: {
    campaigns: {
      type: Array
    },
    banners: Array,
    isShowcase: Boolean,
    hasFavorite: {
      type: Boolean,
      default: true
    },
    hideCashback: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    campaignList () {
      if (this.isShowcase) return this.banners
      const campaignsFiltered = this.campaigns.filter(campaign => {
        // Filtra as campanhas que são cashback quando hideCashback está ativo
        return !(this.hideCashback && (campaign.is_cashback || campaign.eventData.is_cashback) && !campaign.value)
      })
      const campaignsReducted = campaignsFiltered.reduce((list, campaign, index) => ([
        ...list,
        ...(((!index || !(index % 3)) && !!(this.banners || [])[index / 3])
          ? [{ ...this.banners[index / 3], isBanner: true }, campaign]
          : [campaign])
      ]), [])
      return campaignsReducted
    }
  },

  methods: {
    getCampaignType (c) {
      if (c.isBanner || this.isShowcase) return 'campaign-banner'

      return 'campaign-card'
    },

    click (campaign) {
      if (this.getCampaignType(campaign) === 'campaign-card') {
        this.$emit('click-campaign', campaign)

        window.dataLayer.push({
          event: 'visualizacao-oferta',
          nome_parceiro: campaign.partner.name,
          slug_oferta: campaign.slug,
          titulo_oferta: campaign.title
        })
      }
    },

    getCashbackValue (campaign) {
      return !this.hideCashback && (campaign.eventData || {}).cashback_value
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/reference';

$campaign-list-spacing: 10px;

.campaign-list {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  padding: $campaign-list-spacing;

  &:not(.suggestions) { margin-bottom: 60px;   margin-top: 10px; }

  & > .item {
    width: 100%;
    margin-right: auto;
    margin-left: auto;

    &:not(.-search):hover {
      @include desktop {
        transition: all .3s ease;
        &:hover {
          position: relative;
          box-shadow: 0px 0px 21px 0px rgba(18, 30, 72, 0.5);
        }
      }
    }
  }

  & > .item + .item { margin-top: $campaign-list-spacing; }

  @media screen and (min-width: 769px) {
    flex-wrap: wrap;
    flex-direction: row;
    align-items: stretch;
    padding: 5px 10px;

    & > .item {
      flex: { basis: calc(50% - 5px); grow: 0; shrink: 0; }
      margin: { top: 10px; right: 0; left: 0; }
    }

    & > .item:nth-child(1),
    & > .item:nth-child(2) { margin-top: 0; }

    & > .item:nth-child(even) { margin-left: 10px; }
  }

  @media screen and (min-width: 993px) {
    & > .item { flex: calc(100% / 3 - 20px / 3) 0 0; }

    & > .item:nth-child(3) { margin-top: 0; }

    & > .item:nth-child(even) { margin-left: 0; } // Overwrite

    & > .item:nth-child(3n + 2),
    & > .item:nth-child(3n + 3) { margin-left: 10px; }
  }
}

.campaign-list > .item {
  transition: transform .2s ease-out,
              opacity .3s ease-in;
}

.campaign-list-enter,
.campaign-list-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.campaign-list-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/Campaign/CampaignList.vue